import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, professionalServiceJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/contact")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Contact Shugert: Premium Shopify Agency",
    description: "Talk to the Shugert team about your Shopify project. We reply within 1 business day and quote scope, timeline, and pricing up front.",
    path: "/contact",
    altPath: alternatePath("/contact", "es"),
    jsonLd: [professionalServiceJsonLd("en"), breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])],
  }),
});
